export const VERSION = '0.39.0'; // x-release-please-version
